// store.js
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import leagueReducer from "../features/league/leagueReducer";
import lineupReducer from "../features/lineup/lineupReducer";
import userReducer from "../features/user/userReducer";
import eventReducer from "../features/event/eventReducer";
import notificationReducer from "../features/notification/notificationReducer";

const rootReducer = combineReducers({
  league: leagueReducer,
  lineup: lineupReducer,
  user: userReducer,
  event: eventReducer,
  notifications: notificationReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["league", "user", "event", "notifications"], // Removed "lineup" - should be fetched fresh
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
